import { Component, OnInit, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductStockError } from '../../models/product-stock-error';
import { ProductStockInformation } from '../../models/product-stock-information';

@Component({
  selector: 'app-no-product-dialog',
  templateUrl: './no-product-dialog.component.html',
  styleUrls: ['./no-product-dialog.component.css']
})
export class NoProductDialogComponent implements OnInit {

  productStockError: ProductStockError;

  constructor(
    public dialogRef: MatDialogRef<NoProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.productStockError = data.productStockError;
  }

  ngOnInit(): void {
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  get locationIds(): number[] {
    const locationIds = this.productStockError?.productsStockInformation?.map(item => item.locationId);
    if (!locationIds) {
      return [];
    }
    return [...new Set(locationIds)];
  }

  getProductsStockInformationByLocation(locationId: number): ProductStockInformation[] {
    return this.productStockError?.productsStockInformation?.filter(item => item.locationId === locationId) || [];
  }

  getLocationName(locationId: number): string {
    const productStockInformation = this.productStockError?.productsStockInformation?.find(item => item.locationId === locationId);
    return productStockInformation?.locationName;
  }
}
